import { createSelector } from 'reselect';
import { pdpBundlingSelector } from 'selectors/testTarget/offers/pdpBundling/pdpBundlingSelector';

const showSelector = createSelector(pdpBundlingSelector, pdpBundling => !!pdpBundling.show);

export { showSelector };
